import React from "react";
import { withAuth } from "../../hoc";
import { TransformationWODPage } from "./transformation-wod/TransformationWOD";

const TransformationWorkoutOfTheDay = () => {
  return <TransformationWODPage />;
};

export default withAuth(TransformationWorkoutOfTheDay);
